module.exports = __webpack_public_path__ + "img/invitingStudentsSubgroup1.6ff74dbc.jpg";